export default __webpack_public_path__ + "static/media/release-ready.7ac8a6dc.svg";